const agendaPath = accountId => `/app/accounts/${accountId}/v2/kanban`;

export const buildAgendaReturnPath = route => {
  if (!route?.path || !/^\/app\/accounts\/[^/]+\/v2\/kanban$/.test(route.path))
    return null;
  if (route.query?.view !== 'agenda' || route.query?.agenda_return) return null;
  return route.fullPath || null;
};

export const resolveAgendaReturnPath = (value, accountId) => {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/app/') ||
    !accountId ||
    value.length > 4096
  )
    return null;
  let parsed;
  try {
    parsed = new URL(value, 'http://agenda-return.invalid');
  } catch {
    return null;
  }
  if (
    parsed.origin !== 'http://agenda-return.invalid' ||
    parsed.pathname !== agendaPath(accountId) ||
    parsed.searchParams.get('view') !== 'agenda' ||
    [...parsed.searchParams.keys()].some(
      key => parsed.searchParams.getAll(key).length !== 1
    ) ||
    parsed.searchParams.has('agenda_return')
  )
    return null;
  return parsed.pathname + parsed.search + parsed.hash;
};
